import { EntityKind, buildBusinessErrorFromError, } from '@mgdis/eu-domain';
class DemandesFinancementRestAdapter {
    tenantId;
    restHttpAdapter;
    /**
     * API of demande financement.
     */
    constructor({ tenantId, restHttpAdapter }) {
        this.tenantId = tenantId;
        this.restHttpAdapter = restHttpAdapter;
    }
    /**
     * Call API: get demande financement by reference
     *
     * @param reference - reference
     * @param contribution - optional contribution to merge with
     * @returns demande financement
     */
    async getDemandeFinancement(reference, contribution) {
        try {
            const res = await this.restHttpAdapter.get(`/referentiel-financement/api/tenants/${this.tenantId}/demandes-financement/${reference}`, { params: { contribution: contribution } });
            return { response: res.data };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error, { entityKind: EntityKind.DEMANDE_FINANCEMENT }) };
        }
    }
    /**
     * Call API: get demandes financement.
     *
     * @param pagination - pagination
     * @param aggregations - specify if aggregations should be included in result
     * @param sort - sort the list of demandes
     * @param filters - filters to apply on the list of demande
     * @param includeSollicitations - includes awaiting actions on each demande
     * @returns demandes financement
     */
    async getDemandesFinancement(pagination, aggregations = false, sort = null, filters = null, includeSollicitations = true) {
        try {
            const res = await this.restHttpAdapter.post(`/referentiel-financement/api/tenants/${this.tenantId}/demandes-financement/private/depot/search`, { from: pagination.from, size: pagination.size, aggregations, aideSearch: filters, sort, includeSollicitations });
            return { response: res.data };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error, { entityKind: EntityKind.DEMANDE_FINANCEMENT }) };
        }
    }
    /**
     * Call API: count demandes financement.
     *
     * @returns demandes financement
     */
    async countDemandesFinancement() {
        try {
            const res = await this.restHttpAdapter.get(`/referentiel-financement/api/tenants/${this.tenantId}/demandes-financement/private/depot/count`);
            return { response: res.data };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error, { entityKind: EntityKind.DEMANDE_FINANCEMENT }) };
        }
    }
    /**
     * Call API: get demandes financement.
     *
     * @param pagination - pagination
     * @param sort - sort the list of demandes
     *
     * @returns demandes financement
     */
    async getDemandesFinancementShared(pagination, sort) {
        try {
            const res = await this.restHttpAdapter.get(`/referentiel-financement/api/tenants/${this.tenantId}/demandes-financement/private/depot/shared-with-me`, { params: { $skip: pagination.from, $top: pagination.size, sort } });
            return { response: res.data };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error, { entityKind: EntityKind.DEMANDE_FINANCEMENT }) };
        }
    }
    /**
     * Call API: count demandes financement.
     */
    async countDemandesFinancementShared() {
        try {
            const res = await this.restHttpAdapter.get(`/referentiel-financement/api/tenants/${this.tenantId}/demandes-financement/private/depot/shared-with-me/count`);
            return { response: res.data };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error, { entityKind: EntityKind.DEMANDE_FINANCEMENT }) };
        }
    }
    /**
     * Call API: get linked demandes.
     *
     * @returns demandes financement
     */
    async getLinkedDemandesFinancement(idCpo, idToExclude) {
        try {
            const res = await this.restHttpAdapter.get(`/referentiel-financement/api/tenants/${this.tenantId}/demandes-financement/private/depot/linked-demandes-financement`, { params: { idCpo, idToExclude } });
            return { response: res.data };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error, { entityKind: EntityKind.DEMANDE_FINANCEMENT }) };
        }
    }
    /**
     * Call API: Patch a demande by its reference.
     *
     * @returns demande
     */
    async patchDemandeFinancementByReference(reference, patch) {
        try {
            const res = await this.restHttpAdapter.patch(`/referentiel-financement/api/tenants/${this.tenantId}/demandes-financement/${reference}`, patch);
            return { response: res.data };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error, { entityKind: EntityKind.DEMANDE_FINANCEMENT }) };
        }
    }
    /**
     * Call API: Update a demande financement.
     *
     * @param demandeToUpdate - demande to update
     */
    async updateDemandeFinancement(demandeToUpdate) {
        try {
            await this.restHttpAdapter.put(`/referentiel-financement/api/tenants/${this.tenantId}/demandes-financement/${demandeToUpdate.reference}`, demandeToUpdate);
            return { response: null };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error, { entityKind: EntityKind.DEMANDE_FINANCEMENT }) };
        }
    }
    /**
     * Call API: get demandes financement restricted to user.
     *
     * @returns restricted demandes ids
     */
    async getDemandesFinancementRestricted() {
        try {
            const res = await this.restHttpAdapter.get(`/referentiel-financement/api/tenants/${this.tenantId}/demandes-financement/restrictions/forbidden`);
            return { response: res.data };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error, { entityKind: EntityKind.DEMANDE_FINANCEMENT }) };
        }
    }
}
export { DemandesFinancementRestAdapter };
//# sourceMappingURL=demandes-financement-rest.adapter.js.map